import React, { useState } from 'react';
import styled from 'styled-components';
import Sidebar from './Sidebar';
import Footer from './Footer';
import theme from '../styles/theme';

// Componentes estilizados
const LayoutContainer = styled.div`
  display: flex;
  min-height: 100vh;
  background: ${theme.colors.background.primary};
  overflow-x: hidden;
  width: 100%;
  box-sizing: border-box;
`;

const MainContent = styled.main`
  flex: 1;
  margin-left: 280px;
  padding: 0;
  transition: margin-left 0.3s ease;
  overflow-x: hidden;
  width: 100%;
  box-sizing: border-box;
  max-width: 100vw;
  display: flex;
  flex-direction: column;
  gap: 0;

  @media (max-width: ${theme.breakpoints.lg}) {
    margin-left: 0;
  }
`;

const ContentArea = styled.div`
  flex: 1;
  max-width: 1200px;
  margin: 0 auto;
  width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;
  padding: ${theme.spacing[6]};

  @media (max-width: ${theme.breakpoints.lg}) {
    padding: ${theme.spacing[2]} ${theme.spacing[2]};
    padding-top: calc(${theme.spacing[4]} + 60px);
  }
`;

const Header = styled.header`
  margin-bottom: ${theme.spacing[8]};
  width: 100%;
  max-width: 100%;
  box-sizing: border-box;
  overflow-x: hidden;

  @media (max-width: ${theme.breakpoints.lg}) {
    margin-bottom: ${theme.spacing[4]};
  }
`;

const PageTitle = styled.h1`
  color: ${theme.colors.text.primary};
  font-size: ${theme.fontSizes['3xl']};
  font-weight: 700;
  margin-bottom: ${theme.spacing[2]};
  word-wrap: break-word;
  overflow-wrap: break-word;

  @media (max-width: ${theme.breakpoints.lg}) {
    font-size: ${theme.fontSizes.xl};
    padding-left: 0;
    margin-left: 0;
  }
`;

const Breadcrumb = styled.nav`
  display: flex;
  align-items: center;
  gap: ${theme.spacing[2]};
  margin-bottom: ${theme.spacing[6]};
`;

const BreadcrumbItem = styled.span`
  color: ${theme.colors.text.muted};
  font-size: ${theme.fontSizes.sm};

  &:not(:last-child)::after {
    content: '›';
    margin-left: ${theme.spacing[2]};
    color: ${theme.colors.text.muted};
  }
`;

const BreadcrumbLink = styled.button`
  background: none;
  border: none;
  color: ${theme.colors.text.muted};
  font-size: ${theme.fontSizes.sm};
  cursor: pointer;
  transition: color 0.2s ease;

  &:hover {
    color: ${theme.colors.primary[400]};
  }
`;

const Layout = ({ children, title, breadcrumbs = [] }) => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  const toggleSidebar = () => {
    setSidebarOpen(!sidebarOpen);
  };

  return (
    <LayoutContainer>
      <Sidebar isOpen={sidebarOpen} onToggle={toggleSidebar} />
      
      <MainContent>
        <ContentArea>
          <Header>
            {title && <PageTitle>{title}</PageTitle>}
            
            {breadcrumbs.length > 0 && (
              <Breadcrumb>
                {breadcrumbs.map((item, index) => (
                  <React.Fragment key={index}>
                    {item.path ? (
                      <BreadcrumbLink onClick={() => window.history.back()}>
                        {item.label}
                      </BreadcrumbLink>
                    ) : (
                      <BreadcrumbItem>{item.label}</BreadcrumbItem>
                    )}
                  </React.Fragment>
                ))}
              </Breadcrumb>
            )}
          </Header>

          {children}
        </ContentArea>
        <Footer />
      </MainContent>
    </LayoutContainer>
  );
};

export default Layout;
